// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqConfirmationHeaderStyles } from "@insite/content-library/Widgets/RfqConfirmation/RfqConfirmationHeader";
import {
    buttonsSetStyle,
    orderInfoStyle,
} from "@rugby/App/WidgetExtensions/MyAccountPagesSharedStyle/DetailsPage.style";
import { css } from "styled-components";

rfqConfirmationHeaderStyles.title = { ...orderInfoStyle.titleText };

rfqConfirmationHeaderStyles.buttonGridItem = {
    ...rfqConfirmationHeaderStyles.buttonGridItem,
    css: css`
        ${rfqConfirmationHeaderStyles.buttonGridItem?.css}
        align-items: center;
    `,
};

rfqConfirmationHeaderStyles.viewQuotesButton = {
    css: css`
        ${rfqConfirmationHeaderStyles.viewQuotesButton!.css}
        border-radius: 3px;
    `,
};

rfqConfirmationHeaderStyles.continueButton = {
    css: css`
        ${rfqConfirmationHeaderStyles.continueButton!.css}
        border-radius: 3px;
    `,
};

rfqConfirmationHeaderStyles.printButton = buttonsSetStyle.printButton;
